import { render } from "./SuccessOk.vue?vue&type=template&id=6409d9b0&scoped=true"
import script from "./SuccessOk.vue?vue&type=script&lang=js"
export * from "./SuccessOk.vue?vue&type=script&lang=js"

import "./SuccessOk.vue?vue&type=style&index=0&id=6409d9b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6409d9b0"]])

export default __exports__